import {
  getProductBadgeDisplayIcon,
  isFontAwesomeIconRef,
  normalizeFontAwesomeIconRef,
} from "../../../constants/productBadgeOptions";

/**
 * Renders a badge icon from its reference: a FontAwesome reference
 * (e.g. "fa-solid fa-pepper-hot") becomes an <i>, anything else
 * (emoji/symbol, preset badge icons) is rendered as text.
 */
export default function ProductBadgeIcon({ item, className = "" }) {
  const icon = getProductBadgeDisplayIcon(item);
  if (item?.type === "customized" && isFontAwesomeIconRef(icon)) {
    return (
      <i
        className={`${normalizeFontAwesomeIconRef(icon)}${className ? ` ${className}` : ""}`}
        aria-hidden="true"
      />
    );
  }
  return (
    <span className={className} aria-hidden="true">
      {icon}
    </span>
  );
}
